export default __webpack_public_path__ + "static/media/nft.43e77502.gif";